// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Fak_","col":"styles_col__1pb8g","fulfillmentStatus":"styles_fulfillmentStatus__IxQRb","emailCol":"styles_emailCol__1y0sf"};